'use strict';

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.regexp.split");

var extend = require('xtend');

module.exports = function (req) {
  var xhr = req.xhr;
  var props = {
    request: req,
    xhr: xhr
  }; // Try to create the response from the request. If the request was aborted,
  // accesssing properties of the XHR may throw an error, so we wrap in a
  // try/catch.

  try {
    var lines,
        i,
        m,
        headers = {};

    if (xhr.getAllResponseHeaders) {
      lines = xhr.getAllResponseHeaders().split('\n');

      for (i = 0; i < lines.length; i++) {
        if (m = lines[i].match(/\s*([^\s]+):\s+([^\s]+)/)) {
          headers[m[1]] = m[2];
        }
      }
    }

    props = extend(props, {
      status: xhr.status,
      contentType: xhr.contentType || xhr.getResponseHeader && xhr.getResponseHeader('Content-Type'),
      headers: headers,
      text: xhr.responseText,
      body: xhr.response || xhr.responseText
    });
  } catch (err) {}

  return props;
};